import type { ContractDetails } from '@/api/schemas';
import { Field, LABEL_CLASS, VALUE_STRONG_CLASS } from '@/components/Field';
import { PolicyDocumentOpenButton } from '@/components/PolicyDocumentOpenButton';
import { Panel } from '@/components/ui/panel';
import { SectionHeading } from '@/components/ui/section-heading';
import { NOT_AVAILABLE, orNotAvailable } from '@/lib/display';

export function PolicySection({ contract }: { contract: ContractDetails }) {
  return (
    <div>
      <SectionHeading>Policy details</SectionHeading>
      <Panel variant="data" size="wide">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
          <div>
            <p className={LABEL_CLASS}>Policy</p>
            <div className="mt-1 flex items-center gap-2">
              <p className={VALUE_STRONG_CLASS}>{contract.policyNumber}</p>
              <PolicyDocumentOpenButton policyNumber={contract.policyNumber} />
            </div>
          </div>
          <Field
            label="Name & Description"
            value={orNotAvailable(contract.coverage[0]?.coverageDescription)}
            strong={false}
          />
          <Field
            label="Policy Transferability"
            value={NOT_AVAILABLE}
            strong={false}
          />
        </div>
      </Panel>
    </div>
  );
}
